import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Confined Spaces',
  date: new Date(2023, 3, 2),
  img: '/img/bandit.jpeg',
  tracks: [
    {
      title: 'Metered',
      src: '/songs/2023-04-02/metered.mp3',
    },
    {
      title: 'Round Table',
      src: '/songs/2023-04-02/round_table.mp3',
    },
    {
      title: 'Soaring',
      src: '/songs/2023-04-02/soaring.mp3',
    },
    {
      title: 'El Bandito',
      src: '/songs/2023-04-02/el_bandito.mp3',
    },
    {
      title: 'Tabula Rasa',
      src: '/songs/2023-04-02/tabula_rasa.mp3',
    },
    {
      title: 'Tune in at Eleven',
      src: '/songs/2023-04-02/tune_in_at_eleven.mp3',
    },
    {
      title: 'That\'s how you end the Blues',
      src: '/songs/2023-04-02/thats_how.mp3',
    },
    {
      title: 'Esplanade',
      src: '/songs/2023-04-02/esplanade.mp3',
    },
    {
      title: 'Daydreamin\'',
      src: '/songs/2023-04-02/daydreamin.mp3',
    },
    {
      title: 'Last Word',
      src: '/songs/2023-04-02/last_word.mp3',
    },
    {
      title: 'Cold Pursuit',
      src: '/songs/2023-04-02/cold_pursuit.mp3',
    },
    {
      title: 'Shift Change',
      src: '/songs/2023-04-02/shift_change.mp3',
    },
    {
      title: 'Slower Dance',
      src: '/songs/2023-04-02/slower_dance.mp3',
    },
    {
      title: 'Voices',
      src: '/songs/2023-04-02/voices.mp3',
    },
    {
      title: 'Sleep Walking',
      src: '/songs/2023-04-02/sleep_walking.mp3',
    },
    {
      title: 'Humor Me',
      src: '/songs/2023-04-02/humor_me.mp3',
    },
    {
      title: 'Epic Wrap-Up',
      src: '/songs/2023-04-02/epic_wrapup.mp3',
    },
  ]
}
export default album;